module.exports = __webpack_public_path__ + "static/media/icon-uplabs.927cc910.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-uplabs.svg
// module id = 515
// module chunks = 0